import request from "../utils/request";

/////////////////
// GetComponents
/////////////////
export function getLibrariesGetComponents() {
  //скидывает мне по 20   принимает group_id  , если не отправить то аернет все компоненты
  return request({
    url: "/api/settings/components/",
    method: "get"
  });
}

export function getLibrariesGetComponentsByGroup(data) {
  //скидывает мне по 20   принимает group_id  , если не отправить то аернет все компоненты
  return request({
    url: "/api/settings/components/",
    method: "get",
    params: data
  });
}

export function addLibrariesGetComponents(data) {
  return request({
    url: "/api/settings/components/",
    method: "post",
    data
  });
}

export function editLibrariesGetComponents(data) {
  return request({
    url: "/api/settings/components/",
    method: "put",
    data
  });
}

/////////////////
// PDK
/////////////////
export function fetchPDKComponentsApi(params) {
  return request({
    url: "/api/company-objects/pdk-values/",
    method: "get",
    params
  });
}

export function updatePDKComponentsApi(data) {
  // return Promise.resolve(data)
  return request({
    url: `/api/company-objects/pdk-values/${data.id}/`,
    method: "put",
    data
  });
}

/////////////////
// KEN
/////////////////
export function fetchKENComponentsApi(params) {
  return request({
    url: "/api/company-objects/ken-values/",
    method: "get",
    params
  });
}

export function updateKENComponentsApi(data) {
  // return Promise.resolve(data)
  return request({
    url: `/api/company-objects/ken-values/${data.id}/`,
    method: "put",
    data
  });
}

/////////////////
// MeasurmentUnits
/////////////////
export function getLibrariesMeasurmentUnits(params) {
  return request({
    url: "/api/settings/units/",
    method: "get",
    params: {
      type: null
    }
  });
}

export function addLibrariesMeasurmentUnits(data) {
  return request({
    url: "/api/settings/units/",
    method: "post",
    data
  });
}

export function editLibrariesMeasurmentUnits(data) {
  return request({
    url: "/api/settings/units/",
    method: "put",
    data
  });
}

/////////////////
// Ecology Type
/////////////////
export function getEcologyType() {
  return request({
    url: "/api/settings/ecology-type/",
    method: "get"
  });
}

export function addEcologyType(data) {
  return request({
    url: "/api/settings/ecology-type/",
    method: "post",
    data
  });
}

export function editEcologyType(data) {
  return request({
    url: "/api/settings/ecology-type/",
    method: "put",
    data
  });
}

/////////////////
// Subordination
/////////////////

export function getLibrariesSubordination(params) {
  return request({
    url: "/api/company-objects/subordinations",
    method: "get",
    params
  });
}

export function getAllStatisticUsers(params) {
  return request({
    url: "/api/settings/users_list_excel/",
    method: "get",
    params,
    responseType: "blob"
  });
}

/////////////////
// Ownership
/////////////////

export function getLibrariesOwnership() {
  return request({
    url: "/api/settings/ownerships/",
    method: "get"
  });
}

export function addLibrariesOwnership(data) {
  return request({
    url: "/api/settings/ownerships/",
    method: "post",
    data
  });
}

export function editLibrariesOwnership(data) {
  return request({
    url: "/api/settings/ownerships/",
    method: "put",
    data
  });
}

/////////////////
// ActivityField
/////////////////

export function getLibrariesActivityField(params) {
  // url: '/api/settings/activity-fields/',
  return request({
    url: "/api/settings/activity-fields-v2/",
    method: "get",
    params: {
      ordering: " title",
      ...params
    }
  });
}

export function addLibrariesActivityField(data) {
  return request({
    url: "/api/settings/activity-fields/",
    method: "post",
    data
  });
}

export function editLibrariesActivityField(data) {
  return request({
    url: "/api/settings/activity-fields/",
    method: "put",
    data
  });
}

/////////////////
// Departmens
/////////////////

export function getLibrariesDepartments(params) {
  return request({
    // url: '/api/settings/department-subordinations/',
    url: "/api/settings/department-subordinations-v2/",
    method: "get",
    params: {
      ordering: "title",
      ...params
    }
  });
}

export function addLibrariesDepartments(data) {
  return request({
    url: "/api/settings/department-subordinations/",
    method: "post",
    data
  });
}

export function editLibrariesDepartments(data) {
  return request({
    url: "/api/settings/department-subordinations/",
    method: "put",
    data
  });
}

/////////////////
// ObjectsParameters
/////////////////

export function getLibrariesObjectsParameters() {
  return request({
    url: "/api/company-objects/company-param-units/",
    method: "get"
  });
}

export function addLibrariesObjectsParameters(data) {
  return request({
    url: "/api/company-objects/company-param-units/",
    method: "post",
    data
  });
}

export function editLibrariesObjectsParameters(data) {
  return request({
    url: "/api/company-objects/company-param-units/",
    method: "put",
    data
  });
}

/////////////////
// SourceParameters
/////////////////

export function getLibrariesSourceParameters() {
  return request({
    url: "/api/company-objects/polution-units/",
    method: "get"
  });
}

export function addLibrariesSourceParameters(data) {
  return request({
    url: "/api/company-objects/polution-units/",
    method: "post",
    data
  });
}

export function editLibrariesSourceParameters(data) {
  return request({
    url: "/api/company-objects/polution-units/",
    method: "put",
    data
  });
}

/////////////////
// GroupComponents
/////////////////

export function getLibrariesGroupComponents() {
  return request({
    url: "/api/settings/component-group/",
    method: "get"
  });
}

export function getLibrariesGroupComponentsById(data) {
  return request({
    url: "/api/settings/components-by-group/",
    method: "get",
    params: data
  });
}

export function getLibrariesGroupComponentsByEcologyType(data) {
  return request({
    url: "/api/settings/groups-by-ecology-type/",
    method: "get",
    params: data
  });
}

export function getLibrariesGroupComponentsByEcologyTypeIngridient(data) {
  return request({
    url: "/api/settings/components/",
    method: "get",
    params: data
  });
}

export function getLibrariesComponentsByEcologyType(data) {
  // принимает ecology_type_id=1  in_group=false
  return request({
    url: "/api/settings/components-by-ecology-type/",
    method: "get",
    params: data
  });
}

export function addLibrariesGroupComponents(data) {
  return request({
    url: "/api/settings/component-group/",
    method: "post",
    data
  });
}

export function editLibrariesGroupComponents(data) {
  return request({
    url: "/api/settings/component-group/",
    method: "put",
    data
  });
}

export function deleteLibrariesGroupComponents(data) {
  return request({
    url: "/api/settings/component-group/",
    method: "delete",
    data
  });
}

export function editComponentsInGroupComponents(data) {
  return request({
    url: "/api/settings/components-by-group/",
    method: "post",
    data
  });
}

/////////////////
// Ministry
/////////////////

export function getLibrariesMinistry() {
  return request({
    url: "/api/company-objects/ministry/",
    method: "get"
  });
}

/////////////////
// Regions
/////////////////

export function getLibrariesParentRegions() {
  //Только области
  return request({
    url: "/api/settings/parent-regions/",
    method: "get"
  });
}

export function getLibrariesChildRegions(data) {
  //Только районы
  return request({
    url: "/api/settings/child-regions/",
    method: "get",
    params: data
  });
}

export function getLibrariesAllRegions() {
  //Только регионы
  return request({
    url: "/api/settings/get-all-regions/",
    method: "get"
  });
}
